import { inject, Pipe, PipeTransform } from "@angular/core";

import { MedicalIconService } from "./medical-icon.service";

@Pipe({
	name: "medicon",
	standalone: false,
})
export class MedicalIconPipe implements PipeTransform {
	private iconService = inject(MedicalIconService);

	transform(value: string, fallback?: string): string {
		// @ts-expect-error TS2322
		return this.iconService.getIcon(value, fallback);
	}
}
